import { fireEvent } from '../index';
import Modules from '../modules';
import { NAVBAR_EVENTS as Events } from './event';

export const trackRunCMPButtonClick = (clientName: string) => {
  fireEvent(Events.RUN_CAMPAIGN, { tenant_name: clientName, moduleName: Modules.Sequence });
};

export const trackSettingsButtonClick = (clientName: string) => {
  fireEvent(Events.SETTINGS, { tenant_name: clientName, moduleName: Modules.Settings });
};

export const trackChampionTrackingButtonClick = (clientName: string) => {
  fireEvent(Events.CHAMPION_TRACKING, {
    tenant_name: clientName,
    moduleName: Modules['Champions Tracking'],
  });
};
